/** @format */
import Model from '../../models/model';
import util from '../../util';

const UserPasswordForm = new Model({
	name: 'User',
	api: 'User',
	title: 'Client',
	apiParams: ({ searchParams }) => ({ Username: searchParams.get('Username') }),
	customizeSaveData: (toSave, { values }) => {
		toSave.Password = values.Password;
		toSave.Username = values.Username;
		toSave.ClientId ||= null;
		toSave.action = 'otherAction';
		toSave.otherAction = 'AddClient';
		return toSave;
	},
	columns: [
		{
			field: 'Username',
			formField: 'Username',
			header: 'Username',
			disabled: true
		},
		{
			field: 'ClientName',
			formField: 'ClientId',
			header: 'Client',
			lookup: 'Clients',
			inputProps: {
				disableClearable: true,
				getOptionDisabled: (option) => option.isDisable
			},
			type: 'number',
			defaultValue: null,
			required: true
		},
		{
			header: 'Password',
			field: 'Password',
			type: 'password',
			required: true,
			minLength: ({ activeRecord }) => (activeRecord?.id ? 0 : 6),
			maxLength: 50
		},
		{
			header: 'Confirm Password',
			field: 'ConfirmPassword',
			type: 'password',
			validate: 'compare:Password',
			required: true
		},
		{
			header: 'Role',
			field: 'RoleName',
			formField: 'RoleId',
			ignoreLookupOnGridFilter: true,
			width: 150,
			lookup: 'Role',
			required: true,
			onChange: ({ formik, value }) => {
				const roles = util.getRoleValues();
				if ([roles.departmentId, roles.physicianAdminId].includes(value)) {
					formik.setFieldValue('CycleReviewAccess', false);
				}
				else if ([roles.superAdminId, roles.supervisorRoleId, roles.operatorId].includes(value)) {
					formik.setFieldValue('CycleReviewAccess', true);
				}
				if ([roles.operatorId, roles.departmentId, roles.viewerId, roles.administratorId].includes(value)) {
					formik.setFieldValue('PrimaryEmail', '');
				}
			}
		},
		{
			field: 'PrimaryEmail',
			width: 290,
			maxLength: 50,
			validate: 'isEmail',
			required: [
				{
					field: 'RoleId',
					op: 'in',
					value: () => {
						const roles = util.getRoleValues();
						return [
							roles.superAdminId,
							roles.supervisorRoleId,
							roles.huluAdminId,
							roles.sterisSpecialistId
						];
					}
				}
			],
			readOnly: [
				{
					field: 'RoleId',
					op: 'nin',
					value: () => {
						const roles = util.getRoleValues();
						return [
							roles.superAdminId,
							roles.supervisorRoleId,
							roles.huluAdminId,
							roles.sterisSpecialistId
						]
					}
				}
			]
		},
		{
			header: 'CanReview',
			field: 'CycleReviewAccess',
			type: 'bool',
			width: 135,
			defaultValue: true,
			inputWhen: [
				{
					field: 'RoleId',
					op: ({ value }) => {
						const roles = util.getRoleValues();
						const licenseData = util.isLicenseType('catviewer');
						return licenseData && ![roles.viewerId, roles.administratorId, roles.huluAdminId].includes(value);
					}
				}
			],
			disabled: [
				{
					field: 'RoleId',
					op: ({ value }) => {
						const roles = util.getRoleValues();
						return [roles.departmentId].includes(value); //Disable for Department Role
					}
				}
			],
			readOnly: [
				{
					field: 'RoleId',
					op: ({ value }) => {
						const roles = util.getRoleValues();
						return [roles.superAdminId, roles.supervisorRoleId].includes(value); //Read only for supervisor and Steris admin Roles
					}
				}
			]
		}
	]
}).createFormBase();

export default UserPasswordForm;
